import { render, staticRenderFns } from "./VideoAdd.vue?vue&type=template&id=5a9df9b2&scoped=true"
import script from "./VideoAdd.vue?vue&type=script&lang=js"
export * from "./VideoAdd.vue?vue&type=script&lang=js"
import style0 from "./VideoAdd.vue?vue&type=style&index=0&id=5a9df9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9df9b2",
  null
  
)

export default component.exports